export const eSignContractMutualFundStatusTypeNew = 1000;

export const eSignContractMutualFundStatusTypePending = 1001;

export const eSignContractMutualFundStatusTypeApproved = 1002;

export const eSignContractMutualFundStatusTypeSigned = 1003;

export const eSignContractMutualFundStatusOptions = [
  {
    label: 'Đang tạo hợp đồng',
    value: eSignContractMutualFundStatusTypeNew,
  },
  {
    label: 'Đang ký',
    value: eSignContractMutualFundStatusTypePending,
  },
  {
    label: 'Đã ký',
    value: eSignContractMutualFundStatusTypeApproved,
  },
  {
    label: 'Đã hoàn tất',
    value: eSignContractMutualFundStatusTypeSigned,
  },
];
